import { ApiMask, updateApiMask } from '../../../logger/BitMask';
import { Logger } from '../../../logger/Logger';
import { Fetcher } from '../../Fetcher';

import { playerConfigEndpoint } from './endpoints';
import { PlayerConfigType } from './types';

export interface FetchPlayerConfigParams {
  JSESSIONID: string;
  baseUrl: string;
  operatorGameId?: string;
}

export const fetchPlayerConfig = ({
  JSESSIONID,
  baseUrl,
  operatorGameId,
}: FetchPlayerConfigParams): Promise<PlayerConfigType> => {
  return Fetcher.fetch<unknown>(`${baseUrl}${playerConfigEndpoint.url}`, {
    params: {
      JSESSIONID,
    },
    format: playerConfigEndpoint.format,
    root: playerConfigEndpoint.root,
  }).then((response: unknown) => {
    updateApiMask(ApiMask.PlayerConfig);
    const parsedPlayerConfig = playerConfigEndpoint.parser(response, { operatorGameId });
    Logger.updateLocation(parsedPlayerConfig.countryCode);
    return parsedPlayerConfig;
  });
};
